import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {SectionComponent} from '../../../../../../elements/section/section.component';
import {MainBusyBeeComponent} from '../../../../../main/items/main-busy-bee/main-busy-bee.component';
import {Card, CardsArray} from '../../../../../../../model/cards';
import {MainBestHotelsComponent} from '../../../../../main/items/main-best-hotels/main-best-hotels.component';
import {MainDestinationsComponent} from '../../../../../main/items/main-destinations/main-destinations.component';
import {TitleBackgroundComponent} from '../../../../../../elements/title-background/title-background.component';
import {HeaderService} from '../../../../../../../services/header-service';
import {SectionScrollerComponent} from '../../../../../../elements/section-scroller/section-scroller.component';
import {RunningLineComponent} from '../../../../../../elements/running-line/running-line.component';
import {CityService} from '../../../../../../../services/city-service';
import {LocationDto} from '../../../../../../../model/continent';
import {getLastSegment} from '../../../../../../../functions/getLastSegment';
import {environment} from '../../../../../../../environments/environment';
import {NgIf} from '@angular/common';
import {LoopedSliderComponent} from '../../../../../../elements/looped-slider/looped-slider.component';
import {HotelDtoService} from '../../../../../../../services/hotel-dto-service';
import {PaginationParams} from '../../../../../../../model/pagination';
import {Continent} from '../../../../../../../model/circle';
import {CountryService} from '../../../../../../../services/country-service';
import {FooterService} from '../../../../../../../services/footer-service';
import {NavigationService} from '../../../../../../../services/navigation-service';
import {getCssNumber} from '../../../../../../../functions/getCssNumber';
import {findIconByCss, findTextByCss} from '../../../../../../../functions/findIconByAlt';
import {TokenStorageService} from '../../../../../../../services/token.storage.service';
import {AdminPreviewComponent} from '../../../../../../elements/admin-preview/admin-preview.component';
import {getFirstSentence} from '../../../../../../../functions/getFirstSentence';
import {MenuService} from '../../../../../../../services/menu-services';
import {LoadingService} from '../../../../../../../services/loading-service';

@Component({
  selector: 'app-city-page',
  imports: [
    SectionComponent,
    MainBusyBeeComponent,
    MainBestHotelsComponent,
    MainDestinationsComponent,
    TitleBackgroundComponent,
    SectionScrollerComponent,
    RunningLineComponent,
    NgIf,
    LoopedSliderComponent,
    AdminPreviewComponent,
  ],
  templateUrl: './city-page.component.html',
  standalone: true,
  styleUrl: './city-page.component.scss'
})
export class CityPageComponent implements OnInit, OnDestroy {
  constructor(private router: Router,
              private route: ActivatedRoute,
              protected interfaceService: HeaderService,
              protected cityService: CityService,
              protected hotelService: HotelDtoService,
              protected countryService: CountryService,
              public footerService: FooterService,
              public navigationService: NavigationService,
              protected tokenStorageService: TokenStorageService,
              protected menuService: MenuService,
              public loadingService: LoadingService,) {}

  country: string[] = [];
  continent: string[] = [];
  city: string[] = [];

  cityDto: LocationDto = new LocationDto();

  tab: boolean = false;

  loading: boolean = false;
  loadingCircle: boolean = false;

  grid: number = 4.2;

  sliderCards: Card[] = [];
  cityCards: Card[] = [];
  cityAdditionalCards: Card[] = [];
  hotelCards: Card[] = [];

  adminDisplay: boolean = false;
  uncorrectedUrl: boolean = false;
  displayPageFalse: boolean = false;
  typeContent: string | undefined = undefined;

  hotelPaginationParams: PaginationParams = {
    query: '',
    pageSize: 20,
    pageNumber: 0,
    sort: 'rating:asc',
    countryId: ''
  };

  ngOnInit() {
    this.loading = true;
    this.checkLoading();
    this.menuService.setMobileSpecialStyle(true);
    this.interfaceService.setPageInterface('header-container-white');
    this.interfaceService.setHeaderStyle(true);
    if (window.innerWidth < 769) {
      this.tab = true;
      if (window.innerWidth < 456) {
        this.grid = 1.3;
      } else {
        this.grid = 2.1;
      }
    }
    const url = getLastSegment(this.router.parseUrl(this.router.url));
    this.cityService.getCityByUrl(url).subscribe((data) => {
      this.cityDto = new LocationDto(data);
      this.cityDto.button = false;
      this.typeContent = this.cityDto.id?.toString();
      if (this.cityDto.url === ''  ||
        this.cityDto.displayPage === false ||
        this.cityDto.country?.url === '' ||
        this.cityDto.country?.continent?.url === '') {
          if (this.tokenStorageService.getToken() !== undefined) {
            this.adminDisplay = true;
            if (this.cityDto.country?.url === '' || this.cityDto.country?.continent?.url === '' || this.cityDto.url === '') {
              this.uncorrectedUrl = true;
            }
            if (this.cityDto.displayPage === false) {
              this.displayPageFalse = true;
            }
          } else {
            this.navigationService.backOrHome();
          }
      }
      this.footerService.setFooterColor(this.cityDto.country?.continent?.footerColor ?? 'rgba(57, 122, 158, 1)');
      this.footerService.setFooterImage(this.cityDto.footerImage ?? '');
      this.footerService.setFooterStyle(this.cityDto.cssStyleFooterImage ?? '');
      this.sliderCards = this.cityDto.carousels.map((v, index) => {
        const continentCarousel = this.cityDto.country?.continent?.carousels[index];
        if (continentCarousel === undefined) {
          return new Card({
            title: [],
            text: [],
            img: '',
            style: '',
          })
        }
        return new Card({
          id: v.id,
          title: [],
          text: [],
          img: environment.s3Prefix + v.image,
          style: v.cssStyle ?? '',
          cssStyle: v.cssStyle ?? '',
          flex: '',
          cloud: {
            title: [continentCarousel.cloudTitleRu ?? '', continentCarousel.cloudTitleEn ?? ''],
            text: [{text: [continentCarousel.cloudDescriptionRu ?? '', continentCarousel.cloudDescriptionEn ?? '']}],
            link: findTextByCss(continentCarousel.cssStyle, 'link'),
            icon1: findIconByCss(continentCarousel.cssStyle, 'icon', 1),
            icon2: findIconByCss(continentCarousel.cssStyle, 'icon', 2),
            icon3: findIconByCss(continentCarousel.cssStyle, 'icon', 3),
            textEn1: findTextByCss(continentCarousel.cssStyle, 'textEn', 1),
            textEn2: findTextByCss(continentCarousel.cssStyle, 'textEn', 2),
            textEn3: findTextByCss(continentCarousel.cssStyle, 'textEn', 3),
            textRu1: findTextByCss(continentCarousel.cssStyle, 'textRu', 1),
            textRu2: findTextByCss(continentCarousel.cssStyle, 'textRu', 2),
            textRu3: findTextByCss(continentCarousel.cssStyle, 'textRu', 3),
            paddingTop: 0,
            top: getCssNumber(continentCarousel.cssStyle, 'top') ?? 50,
            left: getCssNumber(continentCarousel.cssStyle, 'left') ?? 50,
          }
        });
      });
      this.cityCards = this.cityDto.events.map(v => new Card({
        id: v.id,
        title: [v.titleRu ?? '', v.titleEn ?? ''],
        text: [v.descriptionRu ?? '', v.descriptionEn ?? ''],
        img: v.image ? environment.s3Prefix + v.image : '/app/assets/images/desert.jpg',
        style: v.cssStyle ?? '',
        cssStyle: v.cssStyle ?? '',
        flex: '',
        tag: v.tag,
        tagRu: v.tagRu
      }));
      this.cityAdditionalCards = this.cityDto.additionalEvents.map(v => new Card({
        id: v.id,
        title: [v.titleRu ?? '', v.titleEn ?? ''],
        text: [v.descriptionRu ?? '', v.descriptionEn ?? ''],
        img: v.image ? environment.s3Prefix + v.image : '/app/assets/images/desert.jpg',
        style: v.cssStyle ?? '',
        cssStyle: v.cssStyle ?? '',
        flex: '',
        tag: v.tag,
        tagRu: v.tagRu
      }));
      this.hotelPaginationParams.countryId = this.cityDto.country?.id?.toString() ?? '';
      this.hotelService.getHotelList(this.hotelPaginationParams).subscribe((data) => {
        this.hotelCards = (data.content ?? []).map(v => {
          const path = v.image ? (environment.s3Prefix + v.image) : '/app/assets/images/hotel.png';
          let link: string | null;
          if (v.city?.country?.continent?.url.length != undefined && v.city?.country?.url != undefined) {
            link = v.city?.country?.continent?.url + '/' + v.city?.country?.url + '/' +
              v.city?.url + '/' + v?.url;
          } else {
            link = null
          }
          let descrRu = '';
          let descrEn = '';
          if (v.descriptionRu !== undefined) {
            descrRu = getFirstSentence(v.descriptionRu);
          }
          if (v.descriptionEn !== undefined) {
            descrEn = getFirstSentence(v.descriptionEn);
          }
          return new Card(
            {
              title: ['', ''],
              text: [v.titleRu, v.titleEn],
              img: path,
              style: v.backgroundStyle?.toString() ?? '',
              button: true,
              link: link,
              rating: v.rating ?? 0,
              anotherButton: true,
              anotherHotelButton: true,
              anotherButtonText: [{text: [descrRu, descrEn]}],
            },
          )
        });
        setTimeout(() => {
          this.loading = false;
          this.checkLoading();
        }, 100);
      });
    });
  }

  ngOnDestroy() {
    this.menuService.setMobileSpecialStyle(false);
    this.interfaceService.setHeaderStyle(false);
    this.footerService.setFooterColor('rgba(57, 122, 158, 1)');
    this.footerService.setFooterImage('');
    this.footerService.setFooterStyle('');
  }

  getCorrectLocation() {
    if (this.cityDto == null) {
      return new LocationDto(this.countryService.getRandom())
    } else {
      this.cityDto.destinationsText = [{text: ['город', 'city']}]
      return this.cityDto
    }
  }

  goToDestination(continent: Continent) {
    const url = '/destinations/' + continent.url?.toLowerCase().replaceAll(" ", "-");
    this.router.navigate([url],{relativeTo: this.route}).then(() => {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 0);
    });
  }

  getCorrectTexts(type: string) {
    switch (type) {
      case 'first':
        return [
          {text: ['Тайные ', 'hidden '], fontFamily: 'pd', fontStyle: 'italic', textTransform: 'uppercase'},
          {text: ['уголки', 'gems'], textTransform: 'uppercase'}
        ];
      case 'second':
          return [
            {text: ['Незабываемый ', 'Lifetime '], fontFamily: 'pd', fontStyle: 'italic', textTransform: 'uppercase'},
            {text: ['опыт', 'experience'], textTransform: 'uppercase'}
          ];
      case 'hotel':
        if (window.innerWidth < 576) {
          return [
            {text: ['Рекомендуемые ', 'Finest '], fontFamily: 'pd', fontStyle: 'italic', textTransform: 'uppercase'},
            {text: ['отели', 'Hotels'], textTransform: 'uppercase'}
          ];
        } else {
          return [
            {text: ['Рекомендуемые ', 'Finest '], fontFamily: 'pd', fontStyle: 'italic', textTransform: 'uppercase'},
            {text: ['отели', 'Hotels'], textTransform: 'uppercase'}
          ];
        }
      default: return []
    }
  }

  loadCircle(event: boolean) {
    this.loadingCircle = event;
    this.checkLoading();
  }

  checkLoading() {
    if (this.loading || this.loadingCircle) {
      this.loadingService.setLoadingValue(true);
    }
    if (!this.loading && !this.loadingCircle) {
      this.loadingService.setLoadingValue(false);
    }
  }


  protected readonly CardsArray = CardsArray;
  protected readonly environment = environment;
}
